import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import ImageCompShorttag from './ImageCompShorttag.vue';

export default Node.create({
  name: 'ImageCompShorttag',
  group: 'block',
  atom: true,
  allowGapCursor: true,
  components: {
    ...ImageCompShorttag.components,
  },
  addAttributes() {
    return {
      ...ImageCompShorttag.props,
    };
  },
  parseHTML() {
    return [
      {
        tag: 'image-comp-shorttag',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const returnVal = [
      'figure', [
        'img', {
          src: HTMLAttributes.src,
          alt: HTMLAttributes.alt,
          title: HTMLAttributes.title,
          class: HTMLAttributes.align ? HTMLAttributes.align : '',
        },
      ], [
        'figcaption', {
          html: HTMLAttributes.subtitle,
          class: 'text-center'
        }
      ]
    ];
    return returnVal;
  },
  addNodeView() {
    return VueNodeViewRenderer(ImageCompShorttag);
  },
});
